import { AfterViewInit, Component, Injector, OnInit } from '@angular/core';
import { UserType } from 'src/app/core/enums/user-type.enum';
import { deepCopy } from 'src/app/core/utils/common-functions';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { RolePermissionService } from '../../services/role-permission.service';

@Component({
  selector: 'laas-role-permission',
  templateUrl: './role-permission.component.html',
  styleUrls: ['./role-permission.component.scss']
})
export class RolePermissionComponent extends SessionBaseComponent implements OnInit, AfterViewInit {

  userTypeOptions: any[];
  userTypeSelected: string;
  roleOptions: any[];
  roleSelected: string;

  allPermissions: any[];
  tempPermissions: any[];
  selectedPermission: any[];

  constructor(
    injector: Injector,
    private rolePermissionService: RolePermissionService
  ) {
    super(injector);

    this.userTypeOptions = [];
    this.userTypeSelected = "";
    this.roleOptions = [{
      label: "請選擇",
      value: ""
    }];
    this.roleSelected = "";
    this.allPermissions = [];
    this.tempPermissions = [];
    this.selectedPermission = [];
  }

  async ngAfterViewInit(): Promise<void> {
    //get all permission
    try{
      var result = await this.rolePermissionService.getAllPermission();
      this.allPermissions = result;

      if (this.routeStateService.getCurrent() != undefined) {
        var data = this.routeStateService.getCurrent().data;
        this.userTypeSelected = data.userType;
        this.roleSelected = data.roleSeqNo;
        this.userTypeChange(null);
        this.roleChange(null);
      }
    }catch(err){
      console.log('get All Permission Error');
    }
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    console.log("this.userProfile", this.userProfile);
    this.loader.show();

    //userType Options
    const keys = Object.keys(UserType);
    this.userTypeOptions = keys.map(o => {
      return {
        label: o,
        value: o
      }
    });
    this.userTypeOptions.unshift({
      label: "請選擇",
      value: ""
    });

    this.loader.hide();
  }

  userTypeChange(event: any): void {
    this.selectedPermission = [];
    this.tempPermissions = [];
    this.rolePermissionService.getRoleOptions(this.userTypeSelected).subscribe({
      next: result => {
        this.roleOptions = result.map((x: any) => {
          return {
            label: x.roleName,
            value: x.roleCode
          };
        });

        this.roleOptions.unshift({
          label: "請選擇",
          value: ""
        });
      }
    })
  }

  roleChange(event: any): void{
    this.rolePermissionService.getpermissionByRoleCode(parseInt(this.roleSelected)).subscribe({
      next: result => {
        this.selectedPermission = result;
        this.tempPermissions = deepCopy(this.allPermissions.filter((x: any) => {
          return !result.map((y: any) => y.permissionSeqNo).includes(x.permissionSeqNo);
        })) as any [];
      }
    })
  }

  cancelBtnClick(event: any): void{
    this.routeStateService.loadPrevious();
  }

  modifyBtn(event: any): void{
    this.rolePermissionService.modifyRolePermission(
      parseInt(this.roleSelected),this.userProfile.userName,
      this.selectedPermission
    ).subscribe({
      next: result => {
        this.toastService.success("儲存成功");
      }
    })
  }
}
